
//--------------------------------------
// Set up Vue + Cordova
//--------------------------------------

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

var globalVar = window.top.document

//--------------------------------------
// Load custom CSS for this app
//--------------------------------------

var WebsiteCustomCSS = require('./assets/css/page.styl');

//--------------------------------------
// Load Creek Plugins
//--------------------------------------

import CreekConfigPlugin from './lib/creek/plugins/CreekConfigPlugin.js';
import CreekShowsPlugin from './lib/creek/plugins/CreekShowsPlugin.js';
import CreekLivePlugin from './lib/creek/plugins/CreekLivePlugin.js';
import CreekAudioPlugin from './lib/creek/plugins/CreekAudioPlugin.js';

//--------------------------------------
// Load Vue
//--------------------------------------

Vue.config.productionTip = false;

// First, load the Creek config plugin with initial settings.
Vue.use(CreekConfigPlugin, {
  domain: "kwmr.creek.fm",
  shows: {
    router: {
      enable: true,
      basePath: "/",
      pathPrefix: "#/shows",
      showsPath: "/",
    }
  },
  globalVar
});

//--------------------------------------
// Vue Plugins
//--------------------------------------

/* 
  Shows Plugin:
  - Renders the Show Schedule .
  - Add routes for shows, broadcasts, etc. if an existing router is provided.
  - 
*/ 
Vue.use(CreekShowsPlugin, { globalVar, router });

/*
  Audio Plugin:
  - Adds the audio player components, and central audio system.
  - Allows playback of live and prerecorded audio in the same system.
*/
// Vue.use(CreekAudioPlugin, { globalVar });


Vue.use(CreekAudioPlugin, { globalVar });


import CreekAudioPlayer from './lib/creek/components/AudioPlayer';
import CreekAudioSidebar from './lib/creek/components/AudioSidebar';


// Add the other components
Vue.component(CreekAudioPlayer.name, CreekAudioPlayer)
Vue.component(CreekAudioSidebar.name, CreekAudioSidebar)


/*
  Live Plugin:
  - Includes the Live API and Socket.io
  - Updates the Broadcasting API with the current show, broadcast, and track.
*/
Vue.use(CreekLivePlugin, { globalVar });


//--------------------------------------
// Set up Vue instantiation function
//--------------------------------------

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  head: {
    meta: [
      {
        name: 'viewport',
        content: 'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
      }
    ]
  }
})

